import React from 'react';
import RequireEvent from '../../components/RequireEvent';
import { choose } from '../../utils/platform';
import { useLabels } from './useLabels';
import LabelsDesktop from './Labels.desktop';
import LabelsMobile from './Labels.mobile';

const LabelsView = choose(LabelsDesktop, LabelsMobile);

function LabelsInner({ event }) {
  const vm = useLabels(event);
  return <LabelsView vm={vm} />;
}

export default function Labels() {
  return <RequireEvent>{(event) => <LabelsInner event={event} />}</RequireEvent>;
}
